// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Mob_Navbar{
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 30;
}

.Mob_Navbar_right{
    position: absolute;
    padding: 4rem 0rem;
    height: auto;
    width: 100vw;
    animation: slide_left 0.5s linear;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
}

@keyframes slide_left {
    0%{
        width: 0%;
    }
    100%{
        width: 100%;

    }
}
.Mob_Navbar_right >*{
    font-size: 1.2rem;
    padding-bottom:0.4rem ;
    border-bottom: 0.6px solid rgba(0,0,0,0.2) ;
    font-weight: 400;
    letter-spacing: 0.7rem;
    line-height: 1;
}
.hidee>*{
    display: none;
}
.hidden_animation {
    position: absolute;
    width: 0vw;
    padding: 4rem 0rem;
    height: 70vh;
    animation: slide_right 0.5s linear;
}
.hidden_animation> *{
    display: none;
}
@keyframes slide_right {
    0%{
        width: 100%;
    }
    100%{
        width: 0%;
    }
}
.burger{
    position: absolute;
    top:47px;
    right:15px;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    justify-content: center;
}
.burger>div{
    width: 35px;
    height:5px;
}
.burger>:nth-child(1){
    animation: burger1 0.5s linear;
    transform: rotate(0deg);
}
@keyframes burger1 {
    0%{
        transform: rotate(45deg);
    }
    100%{
    transform: rotate(0deg);
    }
}

.burger>:nth-child(2){
    animation: burger2 0.5s linear;
    transform: rotate(0deg);
}
@keyframes burger2 {
    0%{
        transform: rotate(135deg);
    }
    100%{
        transform: rotate(0deg);
    }
}

.cross>:nth-child(1){
    animation: cross1 0.5s linear;
    transform: rotate(45deg);
}
@keyframes cross1 {
    0%{
        transform: rotate(0deg);
    }
    100%{
        transform: rotate(45deg);
    }
}
.cross>:nth-child(2){
    animation: cross2 0.5s linear;
    transform: rotate(135deg);    
}
@keyframes cross2 {
    0%{
        transform: rotate(0deg);
    }
    100%{
        transform: rotate(135deg);
    }
}
@media only screen and (min-width: 1026px){
    .Mob_Navbar{
        display: none !important;
    }
}
@media screen and (max-width: 380px){
    .burger>div {
        width: 24px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/MobileNav/MobileNav.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,SAAS;IACb;IACA;QACI,WAAW;;IAEf;AACJ;AACA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,2CAA2C;IAC3C,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;AACtC;AACA;IACI,aAAa;AACjB;AACA;IACI;QACI,WAAW;IACf;IACA;QACI,SAAS;IACb;AACJ;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,UAAU;AACd;AACA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI;QACI,wBAAwB;IAC5B;IACA;IACA,uBAAuB;IACvB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI;QACI,yBAAyB;IAC7B;IACA;QACI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;AAC5B;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;AACA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;AACA;IACI;QACI,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":[".Mob_Navbar{\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 30;\n}\n\n.Mob_Navbar_right{\n    position: absolute;\n    padding: 4rem 0rem;\n    height: auto;\n    width: 100vw;\n    animation: slide_left 0.5s linear;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    gap: 2rem;\n}\n\n@keyframes slide_left {\n    0%{\n        width: 0%;\n    }\n    100%{\n        width: 100%;\n\n    }\n}\n.Mob_Navbar_right >*{\n    font-size: 1.2rem;\n    padding-bottom:0.4rem ;\n    border-bottom: 0.6px solid rgba(0,0,0,0.2) ;\n    font-weight: 400;\n    letter-spacing: 0.7rem;\n    line-height: 1;\n}\n.hidee>*{\n    display: none;\n}\n.hidden_animation {\n    position: absolute;\n    width: 0vw;\n    padding: 4rem 0rem;\n    height: 70vh;\n    animation: slide_right 0.5s linear;\n}\n.hidden_animation> *{\n    display: none;\n}\n@keyframes slide_right {\n    0%{\n        width: 100%;\n    }\n    100%{\n        width: 0%;\n    }\n}\n.burger{\n    position: absolute;\n    top:47px;\n    right:15px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n    justify-content: center;\n}\n.burger>div{\n    width: 35px;\n    height:5px;\n}\n.burger>:nth-child(1){\n    animation: burger1 0.5s linear;\n    transform: rotate(0deg);\n}\n@keyframes burger1 {\n    0%{\n        transform: rotate(45deg);\n    }\n    100%{\n    transform: rotate(0deg);\n    }\n}\n\n.burger>:nth-child(2){\n    animation: burger2 0.5s linear;\n    transform: rotate(0deg);\n}\n@keyframes burger2 {\n    0%{\n        transform: rotate(135deg);\n    }\n    100%{\n        transform: rotate(0deg);\n    }\n}\n\n.cross>:nth-child(1){\n    animation: cross1 0.5s linear;\n    transform: rotate(45deg);\n}\n@keyframes cross1 {\n    0%{\n        transform: rotate(0deg);\n    }\n    100%{\n        transform: rotate(45deg);\n    }\n}\n.cross>:nth-child(2){\n    animation: cross2 0.5s linear;\n    transform: rotate(135deg);    \n}\n@keyframes cross2 {\n    0%{\n        transform: rotate(0deg);\n    }\n    100%{\n        transform: rotate(135deg);\n    }\n}\n@media only screen and (min-width: 1026px){\n    .Mob_Navbar{\n        display: none !important;\n    }\n}\n@media screen and (max-width: 380px){\n    .burger>div {\n        width: 24px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
